import { useRef } from "react"
import * as wjcCore from "@grapecity/wijmo"
import * as wjcGrid from "@grapecity/wijmo.grid"

/**
 * gridに設定されたHandlerを再度付与しなおすためのcustomHookです
 * 通常のremove addではremoveの際に除外すべきhandler関数のメモリ領域がわからず外せなくなるため利用します。
 * 主にflexgridのhandlerにstateの値を利用している際に更新に追いつくようにするために使います。
 * @param gridEvent remove,addする対象のgridのイベント
 * @param handler remove,addをしたいイベント
 * @returns 既存のイベントを更新する
 */
export const useGridEventHandler = <
  T extends wjcCore.IEventHandler<wjcGrid.FlexGrid, U>,
  U extends wjcCore.EventArgs
>(
  gridEvent: wjcCore.Event<wjcGrid.FlexGrid, U> | undefined | null,
  handler: T
) => {
  const handlerRef = useRef<T | undefined>(handler)

  /**
   * 既存のハンドラーを更新します
   * @returns
   */
  const refreshHandlerFunction = () => {
    if (!gridEvent || !handlerRef.current) return
    gridEvent.removeHandler(handlerRef?.current)
    handlerRef.current = handler
    gridEvent.addHandler(handler)
  }

  /**
   * ハンドラーを削除します
   * @returns
   */
  const deleteHandlerFunction = () => {
    if (!gridEvent || !handlerRef.current) return
    gridEvent.removeHandler(handlerRef.current)
    handlerRef.current = handler
  }

  return { refresh: refreshHandlerFunction, delete: deleteHandlerFunction }
}
